class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.addEventListener('click', this.handleQuantityButtons.bind(this));
    this.addEventListener('change', this.handleQuantityInputs.bind(this));
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.style.overflow = "hidden";

    fetch(`${window.routes.cart_url_discount}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log(data);
        document.querySelector("[data-cartcount]").textContent = `(${data.item_count})`;
      })
      .catch(error => {
        console.error('Fetch error:', error);
      });
    
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    
    document.body.style.overflow = "";
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  handleQuantityButtons(event) {
    const button = event.target.closest('.quantity__button');
    if (!button) return;

    const qtyWrapper = button.closest('notificatio-input');
    if (!qtyWrapper) return;

    const input = qtyWrapper.querySelector('.quantity__input');
    const index = Number(input.dataset.index);
    let newValue = Number(input.value);

    if (button.name === 'plus') newValue++;
    if (button.name === 'minus') newValue = Math.max(0, newValue - 1);

    input.value = newValue;

    this.updateQuantity(index, newValue, input.name, input.dataset.quantityVariantId);
  }

  handleQuantityInputs(event) {
    const input = event.target.closest('.quantity__input');
    if (!input) return;

    const index = Number(input.dataset.index);
    const newValue = Number(input.value);

    this.updateQuantity(index, newValue, input.name, input.dataset.quantityVariantId);
  }

  updateQuantity(line, quantity, name) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map(s => s.id),
        sections_url: window.location.pathname
      })
    })
    .then(res => res.json())
    .then(parsedState => {
      this.renderContents(parsedState);
    });
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-all"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    console.log(selector, html);
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
